var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c('h2',[_vm._v("Regnskapsbilag")]),_c('br'),_c('div',{staticClass:"container text-justify"},[_c('p',[_vm._v("\n            Last ned vedlegget “Slik regnskapsføres YouWish” for forklaring om fakturabilag og hvordan det føres.\n        ")])])])
}]

export { render, staticRenderFns }